import IconifyIcon from '../IconifyIcon';

const LeftSideBarToggle = ({ toggleSidebar }) => {
  return (
    <div className="topbar-item">
      <button type="button" onClick={toggleSidebar} className="button-toggle-menu me-2">
        <IconifyIcon icon="solar:hamburger-menu-broken" style={{ fontSize: '22px' }} />
      </button>
    </div>
  );
};

export default LeftSideBarToggle;
